import React from 'react'
import { useTranslation } from 'react-i18next'
import { Trophy, Flame, RotateCw } from 'lucide-react'
import { Card, CardContent } from '../../../components/ui/card'
import { exercisePRs } from '../../../lib/workoutCalc'

export default function PRBadges({ sets }) {
  const { t } = useTranslation()
  if (!Array.isArray(sets) || sets.length === 0) return null
  const prs = exercisePRs(sets)
  if (prs.heaviestWeight == null) return null

  const badges = [
    {
      icon: Trophy,
      label: t('workout.pr.heaviest'),
      value: t('workout.pr.heaviestValue', {
        weight: Number(prs.heaviestWeight).toLocaleString(undefined, { maximumFractionDigits: 1 }),
        reps: prs.heaviestReps,
      }),
    },
    {
      icon: Flame,
      label: t('workout.pr.bestSet'),
      value: t('workout.pr.bestSetValue', {
        volume: Math.round(prs.bestSetVolume).toLocaleString(),
      }),
    },
    {
      icon: RotateCw,
      label: t('workout.pr.mostReps'),
      value: t('workout.pr.mostRepsValue', {
        reps: prs.mostReps,
        weight: Number(prs.mostRepsWeight).toLocaleString(undefined, { maximumFractionDigits: 1 }),
      }),
    },
  ]

  return (
    <Card>
      <CardContent className="p-3 sm:p-4">
        <p className="text-xs text-muted-foreground mb-2">{t('workout.pr.title')}</p>
        <div className="grid grid-cols-3 gap-2">
          {badges.map(({ icon: Icon, label, value }) => (
            <div
              key={label}
              className="rounded-lg border border-app-primary-500/30 bg-app-primary-50 dark:bg-app-primary-900/20 p-2.5 text-center"
            >
              <Icon className="w-4 h-4 text-app-primary-500 mx-auto mb-1" />
              <p className="text-[10px] uppercase tracking-wide text-app-primary-700 dark:text-app-primary-300">
                {label}
              </p>
              <p className="text-xs font-semibold text-foreground mt-0.5 leading-tight">{value}</p>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
